import React from 'react';
import {FlightTypeSelector} from "../../../../index";
import {useDispatch, useSelector} from "react-redux";
import {retrieveStopoverAvailability, setSwBookState} from "../../../../../store/reducers/search-widget";
import {SW_FLIGHT_TYPES, SW_PASSENGER_TYPES} from "../../../../../store/types";

const FlightTypeSelectorConnected = () => {

    const flightType = useSelector(state => state.sw.book.flightType);
    const withMiles = useSelector(state => state.sw.book.withMiles);
    const passengerType = useSelector(state => state.sw.book.passengerType);
    const promoCode = useSelector(state => state.sw.book.promoCode);
    const multiCityFlowDisabled = Boolean(withMiles || passengerType !== SW_PASSENGER_TYPES.ADULT || promoCode);
    const dispatch = useDispatch();

    return (
        <FlightTypeSelector
            type={flightType}
            onChange={type => {
                dispatch(setSwBookState({flightType: type}));
                dispatch(retrieveStopoverAvailability());
            }}
            disabledTypes={multiCityFlowDisabled ? [SW_FLIGHT_TYPES.MULTI] : []}
        />
    );
};

export default FlightTypeSelectorConnected;